// extracted by mini-css-extract-plugin
export default {"stepper":"OrderHistoryWidget_stepper__S8+XA","stepperItems":"OrderHistoryWidget_stepperItems__bkCc-","error":"OrderHistoryWidget_error__HfxVo"};